import { render, staticRenderFns } from "./EventBuilderPage.vue?vue&type=template&id=64d2f26c&scoped=true"
import script from "./EventBuilderPage.vue?vue&type=script&lang=js"
export * from "./EventBuilderPage.vue?vue&type=script&lang=js"
import style0 from "./EventBuilderPage.vue?vue&type=style&index=0&id=64d2f26c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2f26c",
  null
  
)

export default component.exports